import { type Action, type ThunkDispatch } from '@reduxjs/toolkit';

import { Jwt } from '@pkg/classes';

import { apiFactory } from '@app/client';
import { type RootState } from '@app/store';
import { show2faExpiredLogin } from '@app/store/slices';
import { useAuthTokens } from '@app/store/zustand/Auth/useUserTokens';

export function prefetch2FA(
    dispatch: ThunkDispatch<RootState, void, Action>,
    overrideExpiry?: boolean,
    onSuccessCallback?: () => void,
) {
    return (): Promise<string> => {
        return new Promise((resolve, reject) => {
            const jwt = new Jwt(useAuthTokens.getState().token?.access_token);
            const expired = jwt.is2FAExpired();
            const is2FAEnabled = jwt.is2FAEnabled();

            if (!is2FAEnabled || (!overrideExpiry && !expired)) {
                if (onSuccessCallback) {
                    onSuccessCallback();
                }

                return resolve(apiFactory().token()?.access_token || '');
            }

            dispatch(
                show2faExpiredLogin((token) => {
                    if (token) {
                        if (onSuccessCallback) {
                            onSuccessCallback();
                        }

                        return resolve(token);
                    }

                    return reject();
                }),
            );
        });
    };
}
